<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="12"
    viewBox="0 0 14 12"
  >
    <g
      transform="translate(-214.602 -6.75)"
    >
      <path
        d="M14,.75H0V-.75H14Z"
        transform="translate(214.602 14.5)"
      />
      <path
        d="M9,.75H0V-.75H9Z"
        transform="translate(217.102 11)"
      />
      <path
        d="M9,.75H0V-.75H9Z"
        transform="translate(217.102 18)"
      />
      <path
        d="M14,.75H0V-.75H14Z"
        transform="translate(214.602 7.5)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CenterAlignIcon',
};
</script>
